module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746e_banner_800x600.4ce8d61c.png";